import { render } from "./crop.vue?vue&type=template&id=4f737cc6"
import script from "./crop.vue?vue&type=script&lang=js"
export * from "./crop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__